import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export const languages = {
  KO: 'ko',
  EN: 'en',
};

export type Language = (typeof languages)[keyof typeof languages];

export interface LanguageState {
  value: Language;
}

const browserLocales = navigator.language.trim().split(/-|_/)[0];
const languageInitState: LanguageState = {
  value: browserLocales === 'ko' ? 'ko' : 'en',
};

const languageSlice = createSlice({
  name: 'language',
  initialState: languageInitState,
  reducers: {
    setLanguage: (state, action: PayloadAction<Language>) => {
      const temp = state;
      temp.value = action.payload;
      return temp;
    },
  },
});

export const { setLanguage } = languageSlice.actions;

export default languageSlice;
